module.exports = __webpack_public_path__ + "img/title-dec.52fa587e.png";